<template>
  <div class="select-time-range">
    <el-date-picker
      v-model="val"
      @change="handleUserTriggerChange"
      type="datetimerange"
      range-separator="To"
      start-placeholder="Start date"
      end-placeholder="End date"
      :shortcuts="shortcuts"
      :default-time="['00:00:00', '23:59:59']"
    />
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "SelectTimeRange",
  props: {
    startTime: {
      type: [String, Date],
      default: () => new Date(dayjs().startOf("day").toISOString()),
    },
    endTime: {
      type: [String, Date],
      default: () => new Date(dayjs().endOf("day").toISOString()),
    },
  },
  data() {
    // v-model 只用 Date 类型
    return {
      val: [this.startTime, this.endTime],
      shortcuts: [
        {
          text: "Last week",
          value: () => {
            const end = new Date();
            end.setUTCHours(23, 59, 59, 999);
            const start = new Date();
            start.setUTCDate(start.getUTCDate() - 7);
            start.setUTCHours(0, 0, 0, 0);
            return [start, end];
          },
        },
        {
          text: "Last month",
          value: () => {
            const end = new Date();
            end.setUTCHours(23, 59, 59, 999);
            const start = new Date();
            start.setUTCMonth(start.getUTCMonth() - 1);
            start.setUTCHours(0, 0, 0, 0);
            return [start, end];
          },
        },
        {
          text: "Last 3 months",
          value: () => {
            const end = new Date();
            end.setUTCHours(23, 59, 59, 999);
            const start = new Date();
            start.setUTCMonth(start.getUTCMonth() - 3);
            start.setUTCHours(0, 0, 0, 0);
            return [start, end];
          },
        },
      ],
    };
  },
  methods: {
    handleUserTriggerChange() {
      const toUTCString = (date) =>
        date ? dayjs(date).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null;
      this.$emit("update:startTime", toUTCString(this.val[0]));
      this.$emit("update:endTime", toUTCString(this.val[1]));
    },
  },
  mounted() {
    // 初始化时触发一次
    this.handleUserTriggerChange();
  },
};
</script>

<style lang="scss">
.select-time-range {
  width: 100%;
  display: flex;
  flex-direction: row;
  .el-date-editor {
    flex: 1;
    .el-range-separator {
      width: 80px;
    }
  }
}
</style>
